const PAGE_PARAM = 'page';

export const parsePageParam = (params: URLSearchParams): number => Number(params.get(PAGE_PARAM)) || 1;

export const setPageParam = (params: URLSearchParams, page: number): void => {
  if (page <= 1) {
    params.delete(PAGE_PARAM);
  } else {
    params.set(PAGE_PARAM, String(page));
  }
};

export const applyFiltersToParams = (params: URLSearchParams, filters: object): void => {
  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === '') {
      params.delete(key);
    } else {
      params.set(key, String(value));
    }
  });
};
